(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const menus = [...document.querySelectorAll('details.mega-menu')];
  if (!menus.length) return;

  let closeTimer;
  const setExpanded = (menu, open) => {
    menu.open = open;
    const summary = menu.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  const closeOthers = current => menus.forEach(menu => {
    if (menu !== current) setExpanded(menu, false);
  });

  menus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      if (!desktopQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeOthers(menu);
      setExpanded(menu, true);
    });
    menu.addEventListener('mouseleave', () => {
      if (!desktopQuery.matches) return;
      closeTimer = window.setTimeout(() => setExpanded(menu, false), 180);
    });
    menu.addEventListener('toggle', () => {
      if (menu.open) closeOthers(menu);
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      setExpanded(menu, false);
      menu.querySelector(':scope > summary')?.focus();
    });
  });
})();